<template>
  <div class="page page-join-us">
    <company-intro-nav-bar hide-join-us />
    <rich-text class="join-us-content"
               :content="content"
               v-if="content"
    />
  </div>
</template>

<script>
  import CompanyIntroNavBar from '@/components/CompanyIntroNavbar';
  import { getJoinUsInfo } from '@/services/about';
  import RichText from '@/components/RichText';

  export default {
    name: 'PageJoinUs',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      CompanyIntroNavBar,
      RichText,
    },
    data() {
      return {
        content: '',
        render: {
          pageTitle: '加入我们',
        },
      };
    },
    methods: {
      async getJoinUsInfo() {
        const data = await getJoinUsInfo();
        this.content = data.content;
        this.render = data.render;
      },
    },
    created() {
      this.getJoinUsInfo();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-join-us {
    padding-top: @size-small;
  }

  .join-us-content {
    margin-top: @size-small;
    background: @color-white;
    padding: @size-base;
  }

</style>
